import { Injector } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';

/***
 * Starts the cloudwatch user monitoring tool to collect metrics regarding user activity.
 * @param injector
 */
export const startCloudwatchRUM = (injector: Injector): Promise<void> => new Promise((resolve) => {
	const config = injector.get(AppConfigService);
	switch (config.getConfig().environment) {
		case 'integration': {
			(function (n, i, v, r, s, c, x, z) {
				x = (window as any).AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
				window[n] = function (c, p) {
					x.q.push({ c: c, p: p });
				};
				z = document.createElement('script');
				z.async = true;
				z.src = s;
				document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
			})(
				'cwr',
				'68cc71a6-42e4-4137-b1c7-118a2d9b7f74',
				'1.0.0',
				'us-east-1',
				'https://client.rum.us-east-1.amazonaws.com/1.12.0/cwr.js',
				{
					sessionSampleRate: 1,
					guestRoleArn: 'arn:aws:iam::248419620687:role/RUM-Monitor-us-east-1-248419620687-9426334636561-Unauth',
					identityPoolId: 'us-east-1:24ce027e-74cd-492c-8212-30667671ecac',
					endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
					telemetries: ['performance', 'errors', 'http'],
					allowCookies: true,
					enableXRay: false
				}
			);
			break;
		}
		case 'development': {
			(function (n, i, v, r, s, c, x, z) {
				x = (window as any).AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
				window[n] = function (c, p) {
					x.q.push({ c: c, p: p });
				};
				z = document.createElement('script');
				z.async = true;
				z.src = s;
				document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
			})('cwr', '8c2f1999-b5a4-4aa7-99c0-6d203969301f', '1.0.0', 'us-east-1', 'https://client.rum.us-east-1.amazonaws.com/1.12.0/cwr.js', {
				sessionSampleRate: 1,
				guestRoleArn: 'arn:aws:iam::248419620687:role/RUM-Monitor-us-east-1-248419620687-9970349218461-Unauth',
				identityPoolId: 'us-east-1:94988e37-cf49-4de5-9879-3f25e0e1d273',
				endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
				telemetries: ['performance', 'errors', 'http'],
				allowCookies: true,
				enableXRay: false
			});
			break;
		}
		case 'staging': {
			(function (n, i, v, r, s, c, x, z) {
				x = (window as any).AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
				window[n] = function (c, p) {
					x.q.push({ c: c, p: p });
				};
				z = document.createElement('script');
				z.async = true;
				z.src = s;
				document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
			})(
				'cwr',
				'279fbd72-785d-47ed-bd07-b1733a1b1d2b',
				'1.0.0',
				'us-east-1',
				'https://client.rum.us-east-1.amazonaws.com/1.12.0/cwr.js',
				{
					sessionSampleRate: 1,
					guestRoleArn: 'arn:aws:iam::389411472831:role/RUM-Monitor-us-east-1-389411472831-7203750518461-Unauth',
					identityPoolId: 'us-east-1:636181bf-bbaa-4a7d-a0a4-4a42d37a227e',
					endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
					telemetries: ['performance', 'errors', 'http'],
					allowCookies: true,
					enableXRay: false
				}
			);
			break;
		}
		case 'production': {
			(function (n, i, v, r, s, c, x, z) {
				x = (window as any).AwsRumClient = { q: [], n: n, i: i, v: v, r: r, c: c };
				window[n] = function (c, p) {
					x.q.push({ c: c, p: p });
				};
				z = document.createElement('script');
				z.async = true;
				z.src = s;
				document.head.insertBefore(z, document.head.getElementsByTagName('script')[0]);
			})('cwr', 'c691b058-ca18-4e4f-94f3-60680281ba08', '1.0.0', 'us-east-1', 'https://client.rum.us-east-1.amazonaws.com/1.2.1/cwr.js', {
				sessionSampleRate: 1,
				guestRoleArn: 'arn:aws:iam::467975364708:role/RUM-Monitor-us-east-1-467975364708-4584960518461-Unauth',
				identityPoolId: 'us-east-1:41432a17-ed13-42a6-806e-579093712360',
				endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
				telemetries: ['performance', 'errors', 'http'],
				allowCookies: true,
				enableXRay: false
			});
			break;
		}
	}
	resolve();
});
